module.exports = {
  "props": [
    {
      "name": "active-class",
      "type": "string",
      "source": "groupable",
      "description": {
        "en": "Configure the active CSS class applied when the link is active. You can find more information about the [**active-class** prop](https://router.vuejs.org/api/#active-class) on the vue-router documentation.",
        "ja": "リンクがアクティブなときに適用されるアクティブなCSSクラスを構成します。vue-routerのドキュメントで [**active-class** prop](https://router.vuejs.org/ja/api/#active-class) の詳細をご覧ください。",
        "zh-Hans": "配置在链接激活时应用的 CSS 类。你能够在 vue-router 文档浏览更多 [**active-class** prop](https://router.vuejs.org/api/#active-class)。"
      }
    },
    {
      "name": "disabled",
      "type": "boolean",
      "default": "false",
      "source": "groupable",
      "description": {
        "en": "Disables the expansion-panel content",
        "ja": "expansion-panelのコンテンツを無効にします。",
        "zh-Hans": "禁用扩展面板内容"
      }
    },
    {
      "name": "readonly",
      "type": "boolean",
      "default": "false",
      "source": "v-expansion-panel",
      "description": {
        "en": "Makes the expansion-panel content read only.",
        "ja": "expansion-panel のコンテンツを読み取り専用にします。",
        "zh-Hans": "使扩展面板内容为只读。"
      }
    }
  ],
  "mixins": [
    "groupable",
    "registrable-provide"
  ],
  "slots": [],
  "events": [
    {
      "name": "change",
      "value": "void",
      "description": {
        "en": "Toggles the value of the selected panel",
        "ja": "Toggles the value of the selected panel",
        "zh-Hans": "切换所选面板的值"
      }
    },
    {
      "name": "click",
      "value": "MouseEvent",
      "description": {
        "en": "Mouse click event",
        "ja": "マウスクリック時のイベント",
        "zh-Hans": "鼠标点击事件"
      }
    }
  ],
  "functions": [],
  "name": "v-expansion-panel",
  "sass": [
    {
      "name": "$expansion-panel-border-radius",
      "default": "$border-radius-root !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$expansion-panel-active-margin",
      "default": "16px !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$expansion-panel-header-font-size",
      "default": "0.9375rem !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$expansion-panel-header-min-height",
      "default": "48px !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$expansion-panel-active-header-min-height",
      "default": "64px !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$expansion-panel-header-padding",
      "default": "16px 24px !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$expansion-panel-content-padding",
      "default": "0 24px 16px !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$expansion-panel-popout-max-width",
      "default": "calc(100% - #{$expansion-panel-active-margin * 2}) !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$expansion-panel-popout-active-max-width",
      "default": "calc(100% + #{$expansion-panel-active-margin}) !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$expansion-panel-inset-max-width",
      "default": "100% !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    },
    {
      "name": "$expansion-panel-inset-active-max-width",
      "default": "calc(100% - #{$expansion-panel-active-margin * 2}) !default;",
      "description": {
        "en": "",
        "ja": "",
        "zh-Hans": ""
      }
    }
  ],
  "component": true
}